module.exports = __webpack_public_path__ + "img/pic_miss_search.1766306608134.png";